<template>
  <div>
    <b-alert
      :variant="alert.type"
      dismissible
      fade
      :show="alert.show"
      @dismissed="alert.show = false"
      >{{ alert.message }}</b-alert
    >
    <h1>MwSt. Wechselkurs</h1>
    <div class="row">
      <b-form-datepicker
        v-model="selectedDate"
        value-as-date
        class="col-md-7 mb-2 mx-2"
      />
      <b-form-select
        class="col-md-1 mx-1"
        v-model="newVatExchangeRate.currencyIso"
        :options="currencies"
      ></b-form-select>
      <b-form-input
        class="col-md-3 mx-1"
        v-model="newVatExchangeRate.euroToCurrency"
        @keypress.enter="save()"
      ></b-form-input>
      <b-button size="md" @click="save()" class="float-right mb-2">
        <span class="icon icon-plus"></span>
      </b-button>
    </div>
    <b-table
      class="mt-3"
      :items="rates"
      :fields="tableConfig.fields"
      striped
      hover
    >
      <template v-slot:cell(actions)="data">
        <b-button size="md" @click="remove(data.item)" class="float-right">
          <span class="icon icon-bin"></span>
        </b-button>
      </template>
    </b-table>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>
<script>
export default {
  props: ["passedCurrencies", "vatExchangeRate"],
  data() {
    return {
      currencies: [],
      selectedDate: new Date(),
      rates: [],
      newVatExchangeRate: {
        month: null,
        currencyIso: null,
        euroToCurrency: null,
      },
      tableConfig: {
        fields: [
          { key: "currencyIso", label: "Währung" }, //  Status  Actions
          { key: "euroToCurrency", label: "Umrechnungsfaktor" },
          { key: "month", label: "Datum" },
          { key: "actions", label: "" },
        ],
      },
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated",
      },
      alert: {
        show: false,
        message: null,
        type: null,
      },
    };
  },
  watch: {
    selectedDate: function (n, o) {
      if (
        !(
          n.getYear() == o.getYear() &&
          n.getMonth() == o.getMonth() &&
          n.getDay() == o.getDay()
        )
      ) {
        this.selectedDate = new Date(
          1900 + parseInt(n.getYear()),
          parseInt(n.getMonth()) + 1,
          0,
          0,
          0,
          0,
          0,
        );
        Vue.nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
  },
  methods: {
    save() {
      this.newVatExchangeRate.month =
        1900 +
        this.selectedDate.getYear() +
        "-" +
        (this.selectedDate.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        this.getLastDay(
          this.selectedDate.getYear() + 1900,
          this.selectedDate.getMonth() + 1,
        );
      if (
        !this.newVatExchangeRate ||
        this.newVatExchangeRate.currencyIso === null ||
        this.newVatExchangeRate.currencyIso === ""
      ) {
        this.modalError = {
          show: true,
          message: "Keine Währung wurde angegeben.",
          error: "",
          title: "MwSt. Wechselkurs Speichervorgang",
        };
        return;
      }
      axios
        .get("/vatexchangerate/create", {
          params: {
            month: this.newVatExchangeRate.month,
            currencyIso: this.newVatExchangeRate.currencyIso,
            euroToCurrency: this.newVatExchangeRate.euroToCurrency,
          },
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 400) {
            this.rates.push(response.data);
            this.rates = this.rates
              .sort((a, b) => {
                return b.month.localeCompare(a.month);
              })
              .slice(0, 20);
            this.newVatExchangeRate = {
              month: null,
              currencyIso: null,
              euroToCurrency: null,
            };
            this.alert = {
              show: true,
              message: "Wechselkurs wurde erfolgreich angelegt.",
              type: "success",
            };
          } else {
            this.modalError = {
              show: true,
              message: "Wechselkurs konnte nicht abgespeichert werden.",
              error: "",
              title: "MwSt. Wechselkurs Speichervorgang",
            };
          }
        })
        .catch((error) => {
          this.modalError = {
            show: true,
            message: "Wechselkurs konnte nicht abgespeichert werden.",
            error: error,
            title: "MwSt. Wechselkurs Speichervorgang",
          };
        });
    },
    getLastDay(year, month) {
      if (month == 2) {
        if (year % 400 == 0 || (year % 4 == 0 && year % 100 != 0)) return 29;
        else return 28;
      } else if (
        month == 1 ||
        month == 3 ||
        month == 5 ||
        month == 7 ||
        month == 8 ||
        month == 10 ||
        month == 12
      )
        return 31;
      else return 30;
    },
    remove(elem) {
      axios
        .post("/vatexchangerate/" + elem.id + "/remove", null)
        .then((response) => {
          if (response.status >= 200 && response.status < 400) {
            this.rates = this.rates.filter((x) => {
              return x.id !== elem.id;
            });
            this.alert = {
              show: true,
              message: "Wechselkurs wurde erfolgreich gelöscht.",
              type: "success",
            };
          } else {
            this.modalError = {
              show: true,
              message: "Konnte den Eintrag nicht löschen.",
              error: response,
              title: "Eintrag Löschen",
            };
          }
        })
        .catch((error) => {
          this.modalError = {
            show: true,
            message: "Konnte den Eintrag nicht löschen.",
            error: error,
            title: "Eintrag Löschen",
          };
        });
    },
  },
  mounted() {
    this.rates = this.vatExchangeRate
      .sort((a, b) => {
        return b.month.localeCompare(a.month);
      })
      .slice(0, 20);
    this.currencies = _.uniq(
      this.passedCurrencies.map((x) => {
        return x.country.currencyIso;
      }),
    )
      .filter((x) => {
        return x !== "EUR";
      })
      .map((x) => {
        return {
          value: x,
          text: x,
        };
      });
    this.selectedDate = new Date(
      1900 + parseInt(this.selectedDate.getYear()),
      parseInt(this.selectedDate.getMonth()) + 1,
      0,
      0,
      0,
      0,
      0,
    );
  },
};
</script>
